import { Search32 } from "@carbon/icons-react";
import { Form, Loading } from "carbon-components-react";
import {
  Row,
  Column,
  TextInput,
  Button,
  DataTable,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  TableToolbar,
  TableToolbarContent,
} from "carbon-components-react";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import Card from "../../components/Card/Card";
import http from "../../http-common";

const tableHeaders = [
  {
    header: "Nome",
    key: "name",
  },
  {
    header: "Sobrenome",
    key: "lastName",
  },
  {
    header: "Número de Pontuações",
    key: "scoringCount",
  },
  {
    header: "Tipo de Avaliação",
    key: "evaluationType",
  },
];

const getCellContent = (cell, id) => {
  if (cell.info.header === "name" || cell.info.header === "lastName") {
    return cell.value || "-";
  }

  if (cell.info.header === "scoringCount") {
    return cell.value || 0;
  }

  if (cell.info.header === "evaluationType") {
    return cell.value === "TECHNICAL_EVALUATION"
      ? "Técnica"
      : cell.value === "ADMINISTRATIVE_EVALUATION"
      ? "Administrativa"
      : cell.value || "-";
  }

  return cell.value;
};

const UserScoringStatsPage = () => {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const fetchData = async () => {
    try {
      const response = await http.get("/users/scoring-stats");
      getApplicationData(response);
    } catch (error) {
      console.error("Error fetching user scoring stats:", error);
    }
  };

  const onSearch = async (data) => {
    // Note: The scoring-stats endpoint returns a single list, not searchable
    // This function is kept for compatibility but may need backend support for search
    fetchData();
  };

  const getApplicationData = (response) => {
    // console.log("Fetched user scoring stats:", response.data);
    // Handle single list response instead of paged response
    const data = response.data.map((user) => ({
      id: user.id || user.username,
      name: user.firstName || "-",
      lastName: user.lastName || "-",
      username: user.username || "-",
      scoringCount: user.scoringCount || 0,
      evaluationType: user.evaluationType || "-",
    }));
    setUsers(data);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Card title="Estatísticas de Pontuação do júri">
      <Loading
        active={isLoading}
        description="Active loading indicator"
        withOverlay={true}
      />

      <DataTable rows={users} headers={tableHeaders} isSortable useZebraStyles>
        {({ rows, headers, getHeaderProps, getTableProps }) => (
          <TableContainer>
            <TableToolbar aria-label="data table toolbar">
              <TableToolbarContent>
                <Form
                  className="data-table-search-form"
                  onSubmit={handleSubmit(onSearch)}
                >
                  <Row>
                    <Column sm={6} md={8} lg={8}>
                      <TextInput
                        id="name"
                        labelText=""
                        placeholder="Nome do utilizador"
                        {...register("name")}
                      />
                    </Column>
                  </Row>
                  <Button type="submit" renderIcon={Search32}>
                    Pesquisar
                  </Button>
                </Form>
              </TableToolbarContent>
            </TableToolbar>
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableHeader {...getHeaderProps({ header })}>
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>
                        {getCellContent(cell, row.id)}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DataTable>
    </Card>
  );
};

export default UserScoringStatsPage;
